export default __webpack_public_path__ + "static/media/bell.d2393e3d.svg";